module.exports = __webpack_public_path__ + "static/claudio-f2512ceb32d0b720c2510bf079e4b800.png";